import React from "react";
import {Link, useLocation} from "react-router-dom";
import {styled} from "@mui/material/styles";
import {Drawer, List, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import {
  AvTimer,
  Article,
  ViewModule,
} from "@mui/icons-material";

const Routes = [
  {
    key: 1,
    path: '/planes',
    sidebarName: 'Planes',
    icon: Article,
  },
  {
    key: 2,
    path: '/historialCompras',
    sidebarName: 'Historial de Compras',
    icon: AvTimer,
  },
];

const ExternalRoutes = [
  {
    key: 100,
    path: process.env.REACT_APP_ERP_URL,
    sidebarName: 'MODULO ERP',
    icon: ViewModule,
    backgroundColor: 'rgb(46, 111, 242)',
  },
];

const DrawerContent = () => {
  const location = useLocation()
  const DrawingToolbar = styled('div')(({ theme, open }) => ({
      display: "flex",
      alignItems: "center",
      marginTop: theme.spacing.unit,
      justifyContent: "flex-end",
      padding: "0 8px",
      ...theme.mixins.toolbar,
      minHeight: '50px !important',
    }),
  );

  return (
    <>
      <DrawingToolbar/>
      <List sx={{paddingTop: 0}}>
        {Routes.map(item => (
            <ListItemButton
              key={item.key}
              selected={item.path === location.pathname}
              component={Link}
              to={item.path}
              sx={{
                height: '55px',
                '&.Mui-selected': {
                  backgroundColor: '#f5f6f7',
                  '&:hover': {
                    backgroundColor: '#f5f6f7',
                  },
                },
                '&:hover': {
                  backgroundColor: 'inherit',
                },
              }}
            >
              <ListItemIcon style={{minWidth: '30px'}}>
                <item.icon />
              </ListItemIcon>
              <ListItemText
                primary={item.sidebarName}
                sx={{
                  '& .MuiListItemText-primary': {
                    fontWeight: 'bold',
                    color: '#404041',
                    fontSize: '0.80rem',
                    textTransform: 'uppercase',
                    letterSpacing: '.5px',
                    lineHeight: 0,
                  }
                }}
              />
            </ListItemButton>
        ))}
        {ExternalRoutes.map(item => (
          <ListItemButton
            key={item.key}
            component={'a'}
            href={item.path}
            sx={{
              height: '55px',
              color: 'white',
              backgroundColor: `${item.backgroundColor}`,
              '&:hover': {
                backgroundColor: `${item.backgroundColor}`,
                color: 'white'
              },
            }}
          >
            <ListItemIcon style={{minWidth: '30px', color: 'white'}}>
              <item.icon />
            </ListItemIcon>
            <ListItemText
              primary={item.sidebarName}
              sx={{
                '& .MuiListItemText-primary': {
                  fontWeight: 'bold',
                  fontSize: '0.80rem',
                  textTransform: 'uppercase',
                  letterSpacing: '.5px',
                  lineHeight: 0,
                }
              }}
            />
          </ListItemButton>
        ))}
      </List>
    </>
  )
}

export const Sidebar = (props) => {
  const {drawerWidth, open, handleDrawerOpen} = props;

  return (
    <>
      <Drawer
        sx={{
          display: { xs: 'block', sm: 'none' },
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            backgroundColor: '#cccccc',
            border: 'none',
          },
        }}
        variant="temporary"
        anchor="left"
        open={open}
        onClose={handleDrawerOpen}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <DrawerContent/>
      </Drawer>
      <Drawer
        sx={{
          display: { xs: 'none', sm: 'block' },
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            backgroundColor: '#cccccc',
            border: 'none',
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
        onClose={handleDrawerOpen}
      >
        <DrawerContent/>
      </Drawer>
    </>
  )
}